import { PageNavigationItem } from '../../../components/Navigation/PageNavigation/PageNavigation';

export const PLACE_SUB_LINK_IDS = {
  MAP: 'pl-map',
  GENERAL_INFO: 'pl-generalInfo',
  TOP_SPECIES: 'pl-topSpecies',
  FISHING_REPORTS: 'pl-fishingReports',
  FISHING_REGULATIONS: 'pl-fishingRegulations',
  FISHING_SPOTS: 'pl-fishingSpots',
  NEARBY_CITIES: 'pl-nearbyCities',
  WEATHER: 'pl-weather',
  FAQ: 'pl-faq',
  EXPLORE_MORE: 'pl-explore-more',
};

export function getPlaceSubNavLinks({
  hasSpecies,
  hasCatches,
  hasGeneralInfo,
  hasFishingSpots,
  hasRegulations,
  hasNearbyCities,
}: {
  hasSpecies: boolean;
  hasCatches: boolean;
  hasGeneralInfo: boolean;
  hasFishingSpots: boolean;
  hasRegulations: boolean;
  hasNearbyCities: boolean;
}): PageNavigationItem[] {
  return [
    { id: PLACE_SUB_LINK_IDS.MAP, label: 'Map' },
    ...(hasFishingSpots ? [{ id: PLACE_SUB_LINK_IDS.FISHING_SPOTS, label: 'Fishing spots' }] : []),
    ...(hasSpecies ? [{ id: PLACE_SUB_LINK_IDS.TOP_SPECIES, label: 'Top species' }] : []),
    ...(hasCatches ? [{ id: PLACE_SUB_LINK_IDS.FISHING_REPORTS, label: 'Fishing reports' }] : []),
    ...(hasGeneralInfo ? [{ id: PLACE_SUB_LINK_IDS.GENERAL_INFO, label: 'General info' }] : []),
    { id: PLACE_SUB_LINK_IDS.WEATHER, label: 'Weather' },
    ...(hasRegulations
      ? [{ id: PLACE_SUB_LINK_IDS.FISHING_REGULATIONS, label: 'Regulations' }]
      : []),
    ...(hasNearbyCities ? [{ id: PLACE_SUB_LINK_IDS.NEARBY_CITIES, label: 'Nearby cities' }] : []),
    { id: PLACE_SUB_LINK_IDS.FAQ, label: 'FAQ' },
    { id: PLACE_SUB_LINK_IDS.EXPLORE_MORE, label: 'Explore more' },
  ];
}
